module.exports = __webpack_public_path__ + "images/construction.f14fc6b5.gif";